import FactorViewComponent from "components/Factor/factorView/FactorViewComponent";
import {useSearchParams} from "react-router-dom";

const FactorView = () => {
    const [searchParams, setSearchParams] = useSearchParams();
    const factorId = searchParams.get("factorId");
    const factorType = searchParams.get("factorType");

    return (
        // @ts-ignore
        <FactorViewComponent factorId={factorId} factorType={factorType}/>
    );
};

export default FactorView;
